import { MembershipTypes, UserMembershipStatus } from 'globals/constants'
import { useSelector } from 'react-redux'
import { AuthSliceSelector } from 'store/slices'

export const useMembershipHelper = () => {
  const { Memberships } = useSelector(AuthSliceSelector)

  const CurrentMembership = () => {
    return Memberships.find(
      (membership) =>
        membership.MembershipSlug !== MembershipTypes.CancelledMembership &&
        membership.MembershipSlug !== MembershipTypes.PausedMembership &&
        (membership.Status === UserMembershipStatus.ACTIVE ||
          membership.Status === UserMembershipStatus.CANCELLED_SOON ||
          membership.Status === UserMembershipStatus.PAUSED_SOON)
    )
  }
  const ActiveMembership = () => {
    return Memberships.find((membership) => membership.Status === UserMembershipStatus.ACTIVE)
  }
  const FutureMembership = () => {
    return Memberships.find((membership) => membership.Status === UserMembershipStatus.FUTURE)
  }
  const SoonToBeCancelledMembership = () => {
    return Memberships.find((membership) => membership.Status === UserMembershipStatus.CANCELLED_SOON)
  }
  const IsCancelledMember = () => {
    return ActiveMembership()?.MembershipSlug === MembershipTypes.CancelledMembership
  }
  const userMembershipSlugs = () => Memberships.map((membership) => membership.MembershipSlug)
  const IsPaidMember = () => {
    const paidMembershipSlugs = [
      MembershipTypes.AnnualPremiumMembership,
      MembershipTypes.PremiumMembership,
      MembershipTypes.ProMembership,
      MembershipTypes.AnnualProMembership,
    ]
    return userMembershipSlugs().find((slug) => paidMembershipSlugs.includes(slug as MembershipTypes))
  }
  const IsOldPaidMember = () => {
    const oldPaidMember = [MembershipTypes.PremiumMembership, MembershipTypes.AnnualPremiumMembership]
    return userMembershipSlugs().find((slug) => oldPaidMember.includes(slug as MembershipTypes))
  }
  const IsSoonToBeCancelledUser = () => {
    const isActiveCancelled = ActiveMembership()?.MembershipSlug == MembershipTypes.CancelledMembership
    return isActiveCancelled && !!CurrentMembership()
  }
  const IsSoonToBePaused = () => {
    const isActivePaused = ActiveMembership()?.MembershipSlug == MembershipTypes.PausedMembership
    return isActivePaused && !!CurrentMembership()
  }
  const IsPausedUser = () => {
    return ActiveMembership()?.MembershipSlug === MembershipTypes.PausedMembership
  }
  return {
    CurrentMembership,
    ActiveMembership,
    FutureMembership,
    SoonToBeCancelledMembership,
    userMembershipSlugs,
    IsPaidMember,
    IsOldPaidMember,
    IsCancelledMember,
    IsSoonToBeCancelledUser,
    IsSoonToBePaused,
    IsPausedUser,
  }
}
